<template>
  <div class="csv-bulk-upload">
    <button-dropdown>
      <template #trigger>
        <button
          type="button"
          class="button-dropdown__button button button--gray"
        >
          <span class="button__content">{{ $t('bulkCvsUpload.buttonText') }}</span>
          <i class="button-dropdown__caret icon-arrow-filled-down" />
        </button>
      </template>
      <template #items>
        <div
          class="button-dropdown__item"
          @click="openPopup('replace')"
        >
          <i class="icon-document-replace" /> {{ $t('bulkCvsUpload.replaceList') }}
        </div>
        <div
          class="button-dropdown__item"
          @click="openPopup('add')"
        >
          <i class="icon-document-add" /> {{ $t('bulkCvsUpload.addList') }}
        </div>
        <div class="button-dropdown__divider" />
        <div
          class="button-dropdown__item"
          @click="downloadCsv"
        >
          <i class="icon-document-download" /> {{ $t('bulkCvsUpload.downloadList') }}
        </div>
      </template>
    </button-dropdown>

    <upload-popup
      v-if="popupType"
      :type="type"
      :site-id="siteId"
      :popup-type="popupType"
      @close="closePopup"
    />
  </div>
</template>

<script>
import ButtonDropdown from '../utils/ButtonDropdown.vue';
import UploadPopup from './UploadPopup.vue';

export default {
    components: {
        UploadPopup,
        ButtonDropdown,
    },
    props: {
        siteId: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            popupType: null,
        };
    },
    methods: {
        openPopup(popupType) {
            this.popupType = popupType;
        },
        closePopup() {
            this.popupType = null;
        },
        async downloadCsv() {
            try {
                const response = await this.$api.bulkCSVUpload.CSVDownload({
                    siteId: this.siteId,
                    type: this.type,
                });
                const type = response.headers['content-type'];
                const blob = new Blob([response.data], { type, encoding: 'UTF-8' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${this.type}.csv`;
                link.click();
            } catch (error) {
                this.$api.$handleError(error, this);
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
  .csv-bulk-upload {
    display: inline-block;
    margin-left: 10px;
  }
</style>
